import { z } from 'zod/v4'
import { useLocalSearchParams } from 'expo-router'
import { usePoints } from '@/src/common/hooks/usePoints'
import { useLegacyCard } from '@/src/common/hooks/useCardInformation'

const PointsRedemptionParams = z.object({ creditAmount: z.coerce.number() })

export function usePointsToStatementCreditCreditAmount() {
  return PointsRedemptionParams.safeParse(useLocalSearchParams()).data?.creditAmount || 0
}

export function usePointsRedemption({
  creditAmount,
  dollarsPerPointConversion,
}: {
  creditAmount: number
  dollarsPerPointConversion: number
}) {
  const legacyPointsQuery = usePoints()
  const pointsBalance =
    legacyPointsQuery.initialized && legacyPointsQuery.query.data
      ? legacyPointsQuery.query.data.getPointsBalance.active.value
      : 'loading'

  const pointsToRedeem = Math.floor(creditAmount / dollarsPerPointConversion)

  const cardQuery = useLegacyCard()
  const cardInformation = cardQuery.loading
    ? 'loading'
    : cardQuery.data?.getCreditCardInformation.node

  const maxDollarValue =
    cardInformation === 'loading'
      ? 'loading'
      : (cardInformation?.financialAccount.outstandingBalancePayable ?? 0)

  return {
    pointsBalance,
    cardInformation,
    pointsToRedeem,
    remainingPoints: pointsBalance === 'loading' ? 'loading' : pointsBalance - pointsToRedeem,
    currentBalance:
      cardInformation === 'loading'
        ? 'loading'
        : (cardInformation?.financialAccount.outstandingBalancePayable ?? 0),
    conversionRate: `1 Mesa Point : $${dollarsPerPointConversion}` as const,
    maxDollarValue,
  } as const
}
